import { Autocomplete, TextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";

export default function RHFAutocomplete({
  name,
  label,
  placeholder,
  options = [],
  optionLabel = "label",
  optionValue = "value",
  multiple = false,
  freeSolo = false,
  rules,
  size='small',
  sx,
  ...other
}) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <Autocomplete
          multiple={multiple}
          freeSolo={freeSolo}
          options={options}
          value={field.value ?? (multiple ? [] : null)}
          onChange={(_, value) => field.onChange(value)}
          getOptionLabel={(option) =>
            typeof option === "string"
              ? option
              : option?.[optionLabel] || ""
          }
          isOptionEqualToValue={(option, value) =>
            option?.[optionValue] === value?.[optionValue]
          }
          sx={{ mb: 2, ...sx }}
          {...other}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              placeholder={placeholder}
              error={!!error}
              helperText={error?.message}
              size={size}
              sx={{
                // "& .MuiInputBase-input": { color: "white" },
                // "& label": { color: "#b0b8c4" },
                // "& label.Mui-focused": { color: "#90caf9" },
                // "& .MuiOutlinedInput-root fieldset": { borderColor: "#30455f" },
                // "& .MuiOutlinedInput-root:hover fieldset": { borderColor: "#90caf9" },
                // "& .MuiOutlinedInput-root.Mui-focused fieldset": { borderColor: "#1f6feb" },
                   ...sx,
              }}
            />
          )}
        />
      )}
    />
  );
}
